import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import logo from './footer-logo.png';
import logo2x from './footer-logo@2x.png';
import css from './index.module.css';
import { INFOPAGE, PRIVACY, TERMS } from '../../../router/routes';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <div className={`${css['footer-wrapper']}`}>
      <footer className={`${css['footer']}`}>
        <Link to={INFOPAGE} className={css['logo']}>
          <img
            src={logo}
            srcSet={logo + ' 1x,' + logo2x + ' 2x'}
            alt=""
            className="logo"
          />
        </Link>

        <ul className={css['menu']}>
          <li>
            <a href={TERMS}>{t('components.external.footer.terms')}</a>
          </li>
          <li>
            <a href={PRIVACY}>{t('components.external.footer.privacy')}</a>
          </li>
          <li className={css['no-hover']}>
            <Trans
              i18nKey="components.external.footer.copyright"
              values={{ year: new Date().getFullYear() }}
            />
          </li>
        </ul>
      </footer>
    </div>
  );
}
